import { render, staticRenderFns } from "./NudgeMessage.vue?vue&type=template&id=1879ac28"
import script from "./NudgeMessage.vue?vue&type=script&lang=js"
export * from "./NudgeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports